import React, { useMemo } from 'react';
import { AngleSection } from '@layout';
import { H2 } from '@heading';
import styles from './Highlights.module.scss';

export default function Highlights() {
  const items = useMemo(
    () => data.map((item, index) => <Highlight
      key={index}
      {...item}
    />),
    []
  );

  return (
    <AngleSection>
      <H2>Recent highlights &amp; achivements</H2>
      <ul className={styles.highlights}>{items}</ul>
    </AngleSection>
  );
}

function Highlight({ num, unit, text }) {
  return !num && !text ? null : (
    <li className={styles.item}>
      {num && (
        <strong
          className={styles.num}
          data-unit={unit}
        >
          <span>
            {Number(num).toLocaleString('en-US', {
              maximumFractionDigits: 0
            })}
          </span>
        </strong>
      )}
      {text && <p>{text}</p>}
    </li>
  );
}

const data = [
  {
    num: 1,
    unit: '#',
    text: 'CDLS is the first center of it’s kind in the nation'
  },
  {
    num: 42,
    unit: '%',
    text:
      'Of CDLS early career fellows are womxn of color, and 55% are womxn'
  },
  {
    num: 68,
    unit: '%',
    text:
      'Of CDLS early career fellows are people who are underrepresented minorities, and 69% are people of color'
  },
  {
    num: 16,
    unit: '#',
    text:
      'Awards received/held in 2018-2019 by early career fellows and CDLS leadership'
  },
  {
    num: 41,
    unit: '%',
    text:
      'Of CDLS early career fellows are womxn of color, and 55% are womxn'
  },
  {
    num: 71,
    unit: '#',
    text:
      'Early Career Fellows supported from 26 majors/programs from 15 educational institutions. 5 are high school students, 29 are undergraduates, 6 are recent graduates, 17 are graduate students, and 5 are postdoctoral scientists'
  },
  {
    num: 17,
    unit: '#',
    text:
      'States and 4 countries are represented by CDLS early career fellows'
  },
  {
    num: 1306,
    unit: '#',
    text: 'People reached through service by our early career fellows'
  },
  { num: 20, unit: '%', text: 'Identify as queer, and 1% as transgender' },
  {
    num: 25,
    unit: '#',
    text:
      'Faculty members working with our early career fellows, 9 of whom are also CDLS faculty fellows'
  },
  {
    num: 1,
    unit: '#',
    text:
      'Number of centers in the physical sciences at UCLA that are led by a womxn of color faculty member'
  },
  {
    num: 1088,
    unit: '#',
    text:
      'People who learned about CDLS through outreach from our Director'
  }
];
